import { BorderRadiusTokens, ColorTokens, SizeTypeTokens, StackType, StackAlignItems, StackJustifyContent, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, LineItemCardTypeTokens, } from '@voltmoney/schema';
import React, { memo } from 'react';
import Space from '../space/Space';
import Typography from '../typography/Typography';
import { FlatList } from 'react-native';
import Card from '../card/Card';
import Stack from '../stack/Stack';
import Divider from '../divider/Divider';
const LineItemCardBase = ({ data, type = LineItemCardTypeTokens.DEFAULT, }) => {
    const separator = () => {
        return (React.createElement(Divider, { size: DividerSizeTokens.SM, margin: { vertical: SizeTypeTokens.LG }, color: ColorTokens.Primary_10 }));
    };
    const handleEmpty = () => {
        return (React.createElement(Stack, { justifyContent: StackJustifyContent.flexStart },
            React.createElement(Typography, { label: 'No Data Found', fontSize: FontSizeTokens.SM, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter, fontWeight: '400' })));
    };
    const paddingProps = {
        horizontal: SizeTypeTokens.XL,
        vertical: SizeTypeTokens.XL,
    };
    const renderItem = ({ item, index }) => (
    // <View>
    React.createElement(Stack, { type: StackType.row, alignItems: StackAlignItems.center, justifyContent: StackJustifyContent.spaceBetween, padding: paddingProps },
        React.createElement(Stack, { justifyContent: StackJustifyContent.flexStart },
            React.createElement(Typography, { label: item['title'], fontSize: FontSizeTokens.SM, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter, fontWeight: '400' })),
        React.createElement(Stack, { type: StackType.row, alignItems: StackAlignItems.center, justifyContent: StackJustifyContent.flexEnd },
            item['amount'] > 0 ? (React.createElement(Typography, { label: '₹', color: ColorTokens.Grey_Night, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, fontWeight: '600', numberOfLines: 1 })) : (React.createElement(React.Fragment, null)),
            React.createElement(Space, { size: SizeTypeTokens.SM }),
            React.createElement(Typography, { label: item['amount'], color: ColorTokens.Grey_Night, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, fontWeight: '600', numberOfLines: 1 })))
    // </View>
    );
    return (React.createElement(Card
    // padding={padding}
    , { 
        // padding={padding}
        bgColor: ColorTokens.Primary_05, borderRadius: BorderRadiusTokens.BR2, header: {
            children: (
            // <Stack
            //     type={StackType.row}
            //     alignItems={StackAlignItems.center}
            //     justifyContent={StackJustifyContent.flexStart}
            // >
            //     <Space size={SizeTypeTokens.MD} />
            React.createElement(FlatList, { data: data, ItemSeparatorComponent: separator, ListEmptyComponent: handleEmpty, renderItem: renderItem, keyExtractor: (item, index) => item['id'] })
            // </Stack>
            ),
        } }));
};
export default memo(LineItemCardBase);
export { LineItemCardBase };
